"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestInterceptor = void 0;
class RequestInterceptor {
    constructor(axios) {
        this.axios = axios;
        this.axios = axios;
    }
    rejectRequest(config, message, statusCode) {
        const rejectError = new this.axios.AxiosError(message, statusCode, config);
        return Promise.reject(rejectError);
    }
    register(axiosInst) {
        axiosInst.interceptors.request.use(this.onFulfilled.bind(this), undefined, {
            synchronous: false,
        });
    }
}
exports.RequestInterceptor = RequestInterceptor;
